import React from 'react';
import { Helmet } from 'react-helmet-async';
import { pageJsonLd, renderPageBody } from '../seoPages';

function SeoPage({ page }) {
  const jsonLd = pageJsonLd(page);

  return (
    <>
      <Helmet>
        <title>{page.title}</title>
        <meta name="description" content={page.description} />
        <link rel="canonical" href={page.canonical} />
        {page.author ? <meta name="author" content={page.author} /> : null}
        {jsonLd.map((ld) => (
          <script key={ld['@type']} type="application/ld+json">{JSON.stringify(ld)}</script>
        ))}
      </Helmet>
      <div dangerouslySetInnerHTML={{ __html: renderPageBody(page.id) }} />
    </>
  );
}

export default SeoPage;
